import Action from '../classes/Action';
import {GroupsManager} from '../classes/GroupsManager';
import Engine from '../classes/Engine';
import { CustomEventTypes } from "../globals";
import { IObjectSelection } from '../interfaces/Misc';
import {ActionDescription, ActionParameters} from "../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../classes/api/Decorators";
import { getUuidv4 } from '../classes/utilities/Misc';

@ActionDescription("Creates an object group with a given name")
@ActionParameters({groupName: "string"})
@RegisterActionWithAPI("CreateGroupAction")
export default class CreateGroupAction extends Action
{
	constructor(groupName: string)
	{
		const previousSelection = Engine.getInstance().getPickingManager().getCurrentSelection();
		const groupGuid = getUuidv4();
		super([groupName, groupGuid,  previousSelection], [groupName, previousSelection], "Created Group " + groupName, [groupName]);
	}

	do(groupName: string, groupGuid: string, previousSelection: IObjectSelection) : void
	{
		const group = GroupsManager.createGroup(groupName, groupGuid, previousSelection.objects);
		Engine.getInstance().getPickingManager().selectGroup(group.guid);
		Engine.getInstance().getPickingManager().storeSelection();

		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	undo(groupName: string, previousSelection: IObjectSelection) : void
	{
		Engine.getInstance().getPickingManager().clearSelection();
		GroupsManager.removeGroup(groupName);
		Engine.getInstance().getPickingManager().restoreSelection(previousSelection);
	}

	verify(groupName: string) : boolean
	{
		return (!GroupsManager.getGroupByName(groupName));
	}
}
